import { render, staticRenderFns } from "./system-journal.vue?vue&type=template&id=aa1f79f8"
import script from "./system-journal.vue?vue&type=script&lang=ts"
export * from "./system-journal.vue?vue&type=script&lang=ts"
import style0 from "./system-journal.vue?vue&type=style&index=0&id=aa1f79f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports